<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <TableOrdersB2B></TableOrdersB2B>
            </v-col>
            <v-col>
                <TableServiceCenter></TableServiceCenter>
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="6">
                <last-sales></last-sales>
            </v-col>
            <v-col sm="6">
                <last-orders></last-orders>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <pending-receipts></pending-receipts>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import TableOrdersB2B from "./Widgets/TableOrdersB2B";
    import TableServiceCenter from "./Widgets/TableServiceCenter";
    import PendingReceipts from "./Widgets/PendingReceipts";
    import LastSales from "./Widgets/LastSales";
    import LastOrders from "./Widgets/LastOrders";

    export default {
        components: {
            TableServiceCenter,
            TableOrdersB2B,
            LastOrders,
            LastSales,
            PendingReceipts
        },
        computed: {
            profile() {
                return User.getters.getProfileId
            }
        }
    }
</script>
